import { useCallback } from 'react';

export default function useValidOnFocus(
    isInError: boolean,
    setValid: (isValid: boolean) => void,
    value?: string,
) {
    const setValidOnFocus = useCallback(() => {
        if (!value) {
            if (isInError) {
                setValid(true);
            }
        }
    }, [value, isInError, setValid]);

    return {
        setValidOnFocus,
    };
}
